var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.108,
    height: 9.907,
    viewBox: "0 0 12.108 9.907",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_93",
    "data-name": "Grupo 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M12.108,40.139a.473.473,0,0,0-.472-.472H.472A.473.473,0,0,0,0,40.139V49.1a.473.473,0,0,0,.472.472H11.636a.473.473,0,0,0,.472-.472ZM.943,48.63V43.04l4.741,4.081a.428.428,0,0,0,.3.11.55.55,0,0,0,.322-.11l4.859-4.065V48.63Zm10.221-8.02v1.219c-.079.008-.039.016-.047.016l-5.126,4.3L.959,41.821c-.008-.008-.016-.016-.016-.024V40.61Z",
    transform: "translate(0 -39.667)",
    fill: "#ffbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a04d1bbbee8ddb415dbace58de0b15c4.svg";
export { ForwardRef as ReactComponent };